import React from "react";
import { RenderPrice } from "../../../Common/Function";
import Loading from "../../../Common/Loading";

function WhyUs({ data, landingLoading }) {
  if (landingLoading) {
    return (
      <section className="padding-y-section border-bottom-section border-top-section why-us">
        <div className="container">
          <div className="row">
            <Loading count={2} col={6} height={500} />
          </div>
        </div>
      </section>
    );
  }
  return (
    <section className="padding-y-section border-bottom-section border-top-section why-us">
      <div className="container">
        <div className="row">
          <div className="col-md-6 questions">
            <h4 className="mb-4" style={{ color: "#404040" }}>
              <img
                src={window.origin + "/WebSide/assets/images/why.png"}
                style={{ marginLeft: "5px" }}
                alt="چرا از نیکوتن رزرو کنم؟"
              />
              چرا از نیکوتن رزرو کنم؟
            </h4>
            <div className="row justify-content-end">
              {[
                {
                  icon: window.origin + "/WebSide/assets/images/1.png",
                  p: () => (
                    <p
                      className="text-center"
                      style={{
                        fontWeight: "400",
                      }}
                    >
                      رزرو آسان در <br />
                      هرساعت از شبانه روز
                    </p>
                  ),
                  alt: "رزرو آسان در هرساعت از شبانه روز",
                },
                {
                  icon: window.origin + "/WebSide/assets/images/posht.png",
                  p: () => (
                    <p
                      className=" text-center"
                      style={{
                        fontWeight: "400",
                      }}
                    >
                      پشتیبانی آنلاین
                      <br />و به روز
                    </p>
                  ),
                  alt: "پشتیبانی آنلاین و به روز",
                },
                {
                  icon: window.origin + "/WebSide/assets/images/2.png",
                  p: () => (
                    <p
                      className="text-center "
                      style={{
                        fontWeight: "400",
                      }}
                    >
                      ارائه تخفیف های
                      <br />
                      دوره ای
                    </p>
                  ),
                  alt: "ارائه تخفیف های دوره ایی",
                },
                {
                  icon: window.origin + "/WebSide/assets/images/panel.png",
                  p: () => (
                    <p
                      className=" text-center"
                      style={{
                        fontWeight: "400",
                      }}
                    >
                      پنل اختصاصی برای
                      <br />
                      مدیران مجموعه
                    </p>
                  ),
                  alt: "پنل اختصاصی برای مدیر مجموعه",
                },
                {
                  icon: window.origin + "/WebSide/assets/images/3.png",
                  p: () => (
                    <p
                      className="text-center "
                      style={{
                        fontWeight: "400",
                      }}
                    >
                      پیداکردن نزدیک ترین
                      <br />
                      مجموعه های ورزشی به شما
                    </p>
                  ),
                  alt: "پیداکردن نزدیک ترین مجموعه های ورزشی به شما",
                },
                {
                  icon: window.origin + "/WebSide/assets/images/mogha.png",
                  p: () => (
                    <p
                      className=" text-center"
                      style={{
                        fontWeight: "400",
                      }}
                    >
                      مقایسه مجموعه های
                      <br />
                      ورزشی
                    </p>
                  ),
                  alt: "مقایسه مجموعه های ورزشی",
                },
                {
                  icon: window.origin + "/WebSide/assets/images/moa.png",
                  p: () => (
                    <p
                      className=" text-center"
                      style={{
                        fontWeight: "400",
                      }}
                    >
                      معرفی استخرها، باشگاه ها
                      <br />و سالن های ورزشی
                    </p>
                  ),
                  alt: "معرفی استخر ها ، باشکاه ها و سالن های ورزشی",
                },
                {
                  icon: window.origin + "/WebSide/assets/images/ete.png",
                  p: () => (
                    <p
                      className=" text-center"
                      style={{
                        fontWeight: "400",
                      }}
                    >
                      اطلاع رسانی و ثبت نام
                      <br />
                      کلاس های ورزشی
                    </p>
                  ),
                  alt: " اطلاع رسانی و ثبت نام کلاس های ورزشی",
                },
                {
                  icon: window.origin + "/WebSide/assets/images/tiz.png",
                  p: () => (
                    <p
                      className=" text-center"
                      style={{
                        fontWeight: "400",
                      }}
                    >
                      ساخت تیزر رایگان
                      <br />
                      برای مجموعه های ورزشی
                    </p>
                  ),
                  alt: "ساخت تیزر رایگان  برای مجموعه های ورزشی",
                },
                {
                  icon: window.origin + "/WebSide/assets/images/rayegan.png",
                  p: () => (
                    <p
                      className="text-center "
                      style={{
                        fontWeight: "400",
                      }}
                    >
                      تبلیغات رایگان
                    </p>
                  ),
                  alt: "تبلیغات رایگان",
                },
              ].map((element, key) => {
                return (
                  <div className="col-6 mb-3" key={key}>
                    <div className="d-flex align-items-start justify-content-center justify-content-md-start text-center text-md-start">
                      <div>
                        <img
                          src={element.icon}
                          width={"35px"}
                          height={"35px"}
                          className="mt-1 me-3"
                          alt={element.alt}
                        />
                      </div>
                      <div className="w-100">
                        <span> {element.p()}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="col-md-6 seperator last-reserve">
            <div className="row justify-content-end">
              <div className="col-md-10 px-0">
                <h4 className="mb-2" style={{ color: "#404040" }}>
                  <img
                    style={{ height: "50px", width: "auto" }}
                    src={window.origin + "/WebSide/assets/images/akh.png"}
                    alt="آخرین رزرو های نیکوتن"
                  />
                  آخرین رزروها
                </h4>
              </div>
              {data.map((element, key) => {
                return (
                  <div
                    key={key}
                    className={`col-md-10 mb-1 pb-2 ${
                      key == data.length - 1 ? "" : "border-bottom "
                    }  last-reserve-card`}
                  >
                    <div className="d-flex justify-content-between">
                      <h6
                        style={{
                          color: "#000000",
                          fontWeight: "500",
                        }}
                      >
                        {element.item_name}
                      </h6>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p
                        className="address-item"
                        style={{
                          color: "#878787",
                          fontWeight: "400",
                          fontSize: "13px",
                        }}
                      >
                        {element.address}
                      </p>
                      <p
                        className="item-price"
                        style={{ color: "#878787", fontWeight: "400" }}
                      >
                        {RenderPrice({ price: element.total_price })}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyUs;
